import React from 'react'
import ReactDOM from 'react-dom'

import thunk from 'redux-thunk'
import Validator from 'validatorjs'
import { Provider } from 'react-redux'
import { createBrowserHistory } from 'history'
import { createStore, applyMiddleware } from 'redux'
import { ConnectedRouter, routerMiddleware } from 'react-router-redux'

import registerServiceWorker from './registerServiceWorker'

import RequestStatus from './components/RequestStatus'


import createRoutes from 'routes'
import createReducer from 'reducers'

import 'styles/app.scss'
import 'bootstrap/dist/css/bootstrap.css'

var messages = Validator.getMessages('es')
messages.required = 'Este campo es obligatorio'
Validator.setMessages('es', messages)
Validator.useLang('es')

export const history = createBrowserHistory()

const store = createStore(
  createReducer(),
  applyMiddleware(thunk),
  applyMiddleware(routerMiddleware(history))
)


const App = () => {
  return (
    <Provider store={ store }>
      <ConnectedRouter history={ history } >
        <div className="full-container">
          { createRoutes() }
          <RequestStatus />
        </div>
      </ConnectedRouter>
    </Provider>
  )
}


// don't try to render if running in test mode
// it'll throw an error related to an invalid DOM Element.
if (process.env.NODE_ENV !== 'test') {
  ReactDOM.render(
    <App />,
    document.getElementById('app')
  )
  // not used on test env
  registerServiceWorker()
}


export default App



// WEBPACK FOOTER //
// ./src/app.js